import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Newsletter() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", consent: false });
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!form.name || form.name.trim().length < 2) errs.name = t("newsletter.errorName");
    const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(form.email)) errs.email = t("newsletter.errorEmail");
    if (!form.consent) errs.consent = t("newsletter.errorConsent");
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      const subs = JSON.parse(localStorage.getItem("anvoriq_newsletter") || "[]");
      subs.push({ name: form.name.trim(), email: form.email.trim(), ts: new Date().toISOString() });
      localStorage.setItem("anvoriq_newsletter", JSON.stringify(subs));
    } catch (_e) {}
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={onSubmit}
      className="grid grid-cols-1 md:grid-cols-2 gap-4"
      noValidate
      data-testid="newsletter-form"
    >
      <div>
        <label htmlFor="nl-name" className="block text-xs uppercase tracking-[0.12em] text-white/60 mb-2">
          {t("newsletter.nameLabel")}
        </label>
        <input
          id="nl-name"
          type="text"
          className="anv-input-dark"
          placeholder={t("newsletter.namePlaceholder")}
          value={form.name}
          onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
          data-testid="newsletter-name-input"
          autoComplete="name"
        />
        {errors.name && (
          <div className="mt-2 text-xs text-[color:var(--anv-terra)]" data-testid="newsletter-name-error">
            {errors.name}
          </div>
        )}
      </div>
      <div>
        <label htmlFor="nl-email" className="block text-xs uppercase tracking-[0.12em] text-white/60 mb-2">
          {t("newsletter.emailLabel")}
        </label>
        <input
          id="nl-email"
          type="email"
          className="anv-input-dark"
          placeholder={t("newsletter.emailPlaceholder")}
          value={form.email}
          onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          data-testid="newsletter-email-input"
          autoComplete="email"
        />
        {errors.email && (
          <div className="mt-2 text-xs text-[color:var(--anv-terra)]" data-testid="newsletter-email-error">
            {errors.email}
          </div>
        )}
      </div>

      <div className="md:col-span-2">
        <label className="flex items-start gap-3 text-xs text-white/70 leading-relaxed cursor-pointer">
          <input
            type="checkbox"
            className="mt-1"
            checked={form.consent}
            onChange={(e) => setForm((f) => ({ ...f, consent: e.target.checked }))}
            data-testid="newsletter-consent-checkbox"
          />
          <span>{t("newsletter.consent")}</span>
        </label>
        {errors.consent && (
          <div className="mt-2 text-xs text-[color:var(--anv-terra)]" data-testid="newsletter-consent-error">
            {errors.consent}
          </div>
        )}
      </div>

      <div className="md:col-span-2">
        <button type="submit" className="anv-btn-primary" data-testid="newsletter-submit-button">
          {t("newsletter.submit")}
        </button>
      </div>
    </form>
  );
}
